import routes from "src/routes";
import { matchPath } from "react-router-dom";

export const canAccessRoute = (routePath, allowedPermission, token) => {
  if (!routePath || !Array.isArray(allowedPermission)) return { allowed: false, type: 'NONE' };

  let matchedRoute = routes.find(route =>
    matchPath(routePath, { path: route.path, exact: true })
  );

  if (!matchedRoute && routePath.startsWith('/online-help')) {
    matchedRoute = routes.find(route =>
      route.path.startsWith('/online-help') &&
      matchPath(routePath, { path: route.path, exact: false })
    );
  }

  if (!matchedRoute) return { allowed: false, type: 'NONE' };

  const requiredPermission = matchedRoute.permission;

  if (requiredPermission === 'PUBLIC') return { allowed: true, type: 'PUBLIC' };

  if (requiredPermission === 'PASSABLE') return { allowed: !!token, type: 'PASSABLE' };

  const hasPermission = allowedPermission.some(permission => {
    const allPath = permission?.path?.replace(/<([^>]+)>/g, ':$1')?.trim()?.toLowerCase();

    return !!matchPath(requiredPermission.toLowerCase(), { path: allPath, exact: true });
  });

  return { allowed: hasPermission, type: 'PROTECTED' };
};


export const getClosestAllowedRoute = (allowedPermission) => {
  if (!Array.isArray(routes) || routes.length === 0) return null;
  if (!Array.isArray(allowedPermission) || allowedPermission.length === 0) return null;

  for (const permission of allowedPermission) {
    const match = routes.find(route => route.permission && route.permission.toLowerCase() === permission.path?.toLowerCase().trim());
    if (match) {
      return match.path;
    }
  }

  const passableRoute = routes.find(route => route.permission === 'PASSABLE');
  if (passableRoute) {
    return passableRoute.path;
  }

  return null;
};



